import { Button } from "shared/ui/shadcn/button";
import CalendarForm, { CalendarDateI } from "shared/ui/calendar-form";

interface FallbackStepPropsI {
  meetingTakerName: string;
  handleOpenSchedulingLink: () => void;
  isLoading: boolean;
  onRetry: () => void;
  onDateChange: (date: CalendarDateI) => void;
  onNotesChange: (notes: string) => void;
  onBookManually: () => void;
}

export const FallbackStep = ({
  meetingTakerName,
  handleOpenSchedulingLink,
  isLoading,
  onRetry,
  onDateChange,
  onNotesChange,
  onBookManually,
}: FallbackStepPropsI) => (
  <div>
    <div className="mb-4 space-y-2 rounded-lg bg-amber-50 p-4 text-amber-800 typography-body-4">
      <p>
        We couldn't automatically detect the meeting from {meetingTakerName}'s
        calendar. This can happen if the calendar hasn't synced yet, or a
        calendar API hasn't sent us fresh data.
      </p>

      <p>
        You can{" "}
        <span
          className="cursor-pointer font-semibold text-amber-900 hover:underline"
          onClick={handleOpenSchedulingLink}
        >
          still access the scheduling link
        </span>{" "}
        if you're not sure if you have booked a meeting.
      </p>
    </div>

    <Button className="mb-6 w-full" onClick={onRetry}>
      Try pulling the event again
    </Button>

    <p className="mb-4 text-muted-foreground typography-body-4">
      <span className="font-semibold text-black">Note:</span> If the event still
      isn't detected, please enter the meeting details manually below.
    </p>

    <div className="mb-4">
      <p className="mb-1 typography-body-4-medium">Meeting with</p>
      <p className="text-base-content/70 typography-body-4">
        {meetingTakerName}
      </p>
    </div>

    <CalendarForm
      bookingDeadlineInMonths={false}
      isNotes
      notesLabel="Notes"
      onDateChange={onDateChange}
      onNotesChange={onNotesChange}
      successButton={{
        text: isLoading ? "Finishing..." : "Book meeting",
        type: "button",
        onClick: onBookManually,
        disabled: isLoading,
      }}
    />
  </div>
);
